import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestOccupancyTrackerList(value) {
  let params = {
    limit: Number.MAX_SAFE_INTEGER,
  };
  if (value === undefined) {
    return fetch.get(`${BASE_URL}/api/app/occupancy-tracker`, {
      params,
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/occupancy-tracker?${value}`);
  }
}

export function requestOccupancyTrackerListFloorWise(value) {
  let params = {
    limit: Number.MAX_SAFE_INTEGER,
  };
  if (value === undefined) {
    return fetch.get(`${BASE_URL}/api/app/occupancy-tracker/getOtFloorWise`, {
      params,
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/occupancy-tracker/getOtFloorWise?${value}`);
  }
}

export function requestLeadReportData(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getleadPipeline`);
  } else {
    return fetch.post(
      `${BASE_URL}/api/app/dashboard/getleadPipeline`,
      params
    );
  }
}

export function requestGetTopDealWon(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getTopDealWon`);
  } else {
    return fetch.post(
      `${BASE_URL}/api/app/dashboard/getTopDealWon`,
      params
    );
  }
}

export function requestSalesReportData(params) {
  if (params === undefined) {
    return fetch.post(`${BASE_URL}/api/app/dashboard/getProposalPipeline`);
  } else {
    return fetch.post(
      `${BASE_URL}/api/app/dashboard/getProposalPipeline`,
      params
    );
  }
}

export function requestOTStatusUpdate(value) {
  return fetch.patch(`${BASE_URL}/api/app/occupancy-tracker/updateOtStatus`, {
    ...value,
  });
}

export function requestOccupancyGraphFloorWise(params) {
  if (params !== undefined) {
    const data = { ...params }; //${data.location_id}
    return fetch.get(
      `${BASE_URL}/api/app/business-center/getOtFloorSeatDetails/${data.businesscenterId}?startDate=${data.startDate}&endDate=${data.endDate}`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}

export function requestOtFloorSuiteDetails(params) {
  if (params !== undefined) {
    const data = { ...params };
    return fetch.get(
      `${BASE_URL}/api/app/business-center/getOtFloorSuiteDetails/${data.businesscenterId}?startDate=${data.startDate}&endDate=${data.endDate}`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}
